module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/team-1-21d3712c6b7b5f4dae7edd75e145290a.png";